import {atom} from 'recoil';

import {globalSearchParams} from '_/utilities';

export type CasusPathStateValue = {
  lastVisited?: string;
  casusSpecifics: {
    folderId?: string;
    [globalSearchParams.invoicing.clientMoney.bookingId]?: string;
    [globalSearchParams.invoicing.payments.paymentId]?: string;
    [globalSearchParams.invoicing.invoices.invoiceId]?: string;
    [globalSearchParams.invoicing.invoiceContainers.containerId]?: string;
    [globalSearchParams.invoicing.fees.activeFeeId]?: string;
    [globalSearchParams.notes.activeNoteId]?: string;
    [globalSearchParams.tasks.activeTaskId]?: string;
    [globalSearchParams.documents.activeDocumentId]?: string;
    [globalSearchParams.logView.activeArtifactId]?: string;
  };
};

export const casusPathState = atom<Record<string, CasusPathStateValue>>({
  key: 'casusPathState',
  default: {},
});
